{
	"releases": [
		{
			"version": "2.42.0",
			"date": "2026-07-07",
			"sections": [
				{
					"heading": "New & Improved",
					"items": [
						"Map Print to PDF: Print or export a map view to PDF from Map-Based Review Mode, with configurable elements and support for multi-page exports  (IKE Office Pro only).",
						"Select Poles on the Map: Select multiple poles directly on the map, using ctrl/cmd-click to quickly build a group (IKE Office Pro only).",
						"Shapefile Export: Export collection points and vectors directly as shapefiles (.shp, .shx, .dbf, .prj) in a single .zip (IKE Office Pro only).",
						"Accurate Anchors in KML Export: Anchors captured with the Accurate Anchor tool now display in KML exports from IKE Office.",
						"Form-First View in Map-Based Review Mode: Collections with no photos now open to the form by default in Map Mode, making it faster to name and edit new collections. (IKE Office Pro only).",
						"IKE PoleForeman Circuit Type Cleanup: The Power Circuit Type field on IKE PoleForeman forms no longer lists Aerial, Spacer, or FOSC options now that these have their own dedicated subforms.",
						"DDS Form Field Support: DDS form schema and exports now include Temperature and GLC fields.",
						"Geodetic Datum Information: IKE Office now displays and exports the geodetic datum (e.g., WGS84, NAD83) for field-collected locations (IKE Office Pro only).",
						"PLS CADD Form Migration: Form migration now supports PLS CADD forms, allowing data to move from older form versions to newer ones of the same type (IKE Office Pro only)."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Date form fields can now be properly edited.",
						"Fielded Accurate Anchor data from IKE Office now imports correctly into PLA software (e.g. IKE PoleForeman, OCalc, SpidaCalc)",
						"Form Builder no longer allows users to save nested lists with invalid data - the invalid fields will display in red to indicate errors. ",
						"Duplicating a subform with Accurate Anchor field now clears placement, bearing, and lead length as expected within the new subform.",
						"The Accurate Anchor watermark now appears correctly on the image in PhotoMeasure when hovering over the orientation field in the form.",
						"Span guy size is now included in the IKE Office DDS export and imports correctly.",
						"Backend maintenance and reliability improvements."
					]
				}
			]
		},
		{
			"version": "2.41.1",
			"date": "2026-06-15",
			"sections": [
				{
					"heading": "Bug Fixes",
					"items": ["Hotfix: Restored expected display for decimal values when using the metric user setting."]
				}
			]
		},
		{
			"version": "2.41.0",
			"date": "2026-06-08",
			"sections": [
				{
					"heading": "New & Improved",
					"items": [
						"Release Notes Notifications: A red dot now appears on the Help and Resources menu when a new IKE Office release is available. Clicking Release Notes opens a window with details on the latest features, bug fixes, and updates.",
						"Dedicated Orientation Field: A new orientation field is available in Form Builder, validating entries between 0-360 degrees. This replaces the previous generic number field on new PLA and Base Forms going forward.",
						"Duplicated Collections Preserve Links: Collection and span links are now preserved when duplicating collections. If a connected pole is not duplicated, the associated vector length and bearing are retained as a manual measurement.",
						"Equipment Subform Type: A dedicated Equipment subform is now available in Base Form and PLA forms, providing better structure for equipment data. All existing IKE Office Pro forms can be updated to include it.",
						"Environment Field in Span Subform: A new Environment field is available in the Span subform on Base Forms and PLA forms, allowing users to describe crossing conditions. The field includes default options and is fully customizable. Note: this field remains locked on SpidaCalc forms for integration purposes.",
						"IKE PoleForeman Altitude Validation: A warning now appears when exported poles contain a missing or zero altitude value, helping catch missed location captures before export."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"IKE PoleForeman export validation now notifies users of mismatched span types and power circuit data between connected poles, and includes a new validation for missing framing selections.",
						"IKE PoleForeman wire attachment heights for Aerial, Spacer, and Fiber Optic Supply Cable circuits are no longer copied between poles when using the span link or copy from existing span tools.",
						"Reverse Geocode (Address) fields now work correctly when added within subforms.",
						"IKE Office now blocks saving a form when duplicate values are incorrectly added to a select list field.",
						"Running Form Migration with a collection selected in PhotoMeasure view now automatically refreshes the page to reflect the updated form structure.",
						"Accurate Anchor form field data (lead length and bearing) can now be edited without clearing the entire field.",
						"Vertical Separation measurements can now be successfully deleted on a MidSpan photo within a copied span.",
						"Fixed an issue where users were blocked from exporting if user settings had not been configured.",
						"Fixed an issue where new poles could not be saved if existing wire MidSpan data had been copied over from an existing pole.",
						"Fixed an issue where certain special characters in a collection form blocked Excel exports.",
						"Behind the scenes maintenance and improvements."
					]
				}
			]
		},
		{
			"version": "2.40.0",
			"date": "2026-05-11",
			"sections": [
				{
					"heading": "New & Improved",
					"items": [
						"New Anchor Subform Type: A dedicated Anchor subform is now available in Base Form and PLA forms, providing better structure for anchor data. Existing forms can be updated to include it.",
						"Operating Company in PoleForeman Form Names: Forms generated from a database connection now display the selected Operating Company in the form name, defaulting to the Organization name when only one Operating Company exists."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Locked fields in Base Form and PLA forms can no longer be accidentally edited, improving data integrity and export reliability.",
						"Excel exports that fail due to unsupported characters now display a clear error message (applies to both general and Importable Excel exports).",
						"DDS exports from IKE Office Pro now correctly export altitude data in feet.",
						"Behind the scenes maintenance and improvements."
					]
				}
			]
		},
		{
			"version": "2.39.1",
			"date": "2026-04-23",
			"description": "Resolved an issue affecting PLA export validation. Warnings and errors now appear as expected."
		},
		{
			"version": "2.39.0",
			"date": "2026-04-21",
			"sections": [
				{
					"heading": "New & Improved",
					"items": [
						"IKE PoleForeman Refresh Form: Custom field positions and selection options are now retained when using the Refresh Form tool on IKE PoleForeman forms — no manual reordering required after a refresh.",
						"Form Archive: Admin and Data Admin users can now archive forms instead of deleting them. Archived forms can be restored at any time and won't appear in IKE Field or for data import.",
						"Non-Wood Pole Type Refinements: Steel, composite, and other non-wood pole types now appear in a structured nested list on OCalc form creation, grouped by Material, Class, and Height.",
						"OCalc Form Upload Validation: IKE Office now validates lccfg files on import, surfacing errors and warnings on upload (prior to form creation).",
						"Persistent Map Settings: Map or Satellite view selection now persists across view switches, page refreshes, and department changes in both the Big Map view and PhotoMeasure Map inset.",
						"Measure Tool in Map Based Review Mode: A new point-to-point distance and bearing measurement tool is available in Map Based Review Mode. This works between collections or any two selected map locations.",
						"Multi-Job Excel Import via Zip File: Upload a zip containing multiple Excel files to create or update multiple jobs at once. Validation is surfaced at the job level, and the file size limit has been increased to support files over 100KB."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Collections no longer freeze when span information related to an Accurate Anchor field is deleted from a form.",
						"Assign functionality now matches on email address or first/last name, resolving cases where users couldn't be found.",
						"Base Form label updates: Low Power Attachment field is now self-titled; Attachment Height Label in the Make Ready Subform now includes attachment size."
					]
				}
			]
		},
		{
			"version": "2.38.0",
			"date": "2026-03-29",
			"sections": [
				{
					"heading": "New & Improved",
					"items": [
						"Span Linking: New functionality within Span type subforms that automatically creates a two-way link between poles, with the option to link existing unlinked spans via a new modal.",
						"Span Subform for Custom Forms: Users with custom forms can now update their forms to include the Span Subform type, improving data integrity and enabling access to Span Linking.",
						"View Imported Collections on Map: Jobs and collections display a red dot in list and map views if they have not been collected in the field, making it easy to differentiate pre-loaded data from field-collected data.",
						"Improved Export Reliability: Exports with many collections now work more reliably (up to the 1000 collection limit).",
						"Secondary Multiplex Conductor Support: IKE Office now validates and correctly exports Secondary Multiplex cables to IKE PoleForeman.",
						"Validation Error Improvements: The \"Unknown in Unknown is missing\" error no longer appears for missing down guy info and other fields."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Location photos for Target location captures are now retained when editing collections using the Importable Excel.",
						"Image Zip Export now provides a single composite image for each annotated IKEphoto.",
						"Behind the scenes maintenance and improvements."
					]
				}
			]
		},
		{
			"version": "2.37.0",
			"date": "2026-02-23",
			"sections": [
				{
					"heading": "New & Improved",
					"items": [
						"Base Form: All IKE Office users now have access to a Base Form template in Form Builder. Critical data from Base Forms can also be migrated to PLA forms.",
						"Non-Wood Pole Material Support (OCalc): OCalc PLA users can now import and select non-wood pole materials (e.g., steel) in their collection forms.",
						"Increased File Upload Limit: The file upload tool now supports files up to 10MB (previously 4MB).",
						"Create Collections in Map Based Review Mode: A new toolbar button lets users select a location directly on the map to create a new collection.",
						"Ruling Span Tool in Map Based Review Mode: Measure cumulative distance and calculate Ruling Span between selected locations.",
						"Annotations Visible on IKEphotos: Annotations now display on IKEphotos within the photo carousel in Map Based Review Mode."
					]
				},
				{
					"heading": "Bug Fixes",
					"items": [
						"Fixed an issue where collections with Vertical Separation measurements could not be selected within a job after Form Migration.",
						"Resolved an issue where the Address and Map Color form metadata fields were not activating within Base Form for IKE Office Pro users.",
						"Behind the scenes maintenance and improvements."
					]
				}
			]
		}
	]
}
